import React from 'react';
import Select from 'react-select';
import { useRateStore } from '../store/RateStore';
import { infos } from '../models/BalticRoute';

const Info = () => {
    const store = useRateStore();

    const handleInfoChange = (event) => {
        const info = event ? event : null;
        store.setInfo(info);
    };

    return (
        <div
            className="inline"
            style={{
                width: '120px',
            }}
        >
            <Select
                className="basic-single"
                classNamePrefix="list"
                isSearchable={false}
                options={infos}
                onChange={handleInfoChange}
                value={store.info}
                openMenuOnFocus={true}
                menuPlacement="auto"
                placeholder="Info"
            />
        </div>
    );
};

export default Info;
